import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import {
  ApplicationConfig,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  TitleStrategy,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { reauthenticationInterceptor } from './core/auth/reauthentication.interceptor';
import { AuthService } from './core/auth/auth.service';
import { PasswordPolicyService } from './core/auth/password-policy.service';
import { ThemeService } from './core/theme/theme.service';
import { BsiteTitleStrategy } from './core/title/bsite-title.strategy';
import { provideDashboardNavigation } from './features/dashboard/dashboard.nav';
import { provideSiteNavigation } from './features/site/site.nav';
import { provideSitesNavigation } from './features/sites-data/sidebar-sites.provider';

// Lingua italiana per date e numeri (formati it-IT).
registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
    ),
    // Gli indirizzi dell'API sono relativi (stessa origine): Angular aggiunge l'intestazione CSRF
    // solo a quelli, sulle richieste che modificano dati.
    provideHttpClient(
      withInterceptors([authInterceptor, reauthenticationInterceptor]),
      withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' }),
    ),
    { provide: LOCALE_ID, useValue: 'it' },
    { provide: TitleStrategy, useExisting: BsiteTitleStrategy },
    // Navigazione dichiarata dalle feature (FR-023): la struttura comune non le conosce.
    provideDashboardNavigation(),
    provideSiteNavigation(),
    provideSitesNavigation(),
    // Il tema si applica subito; poi il cookie CSRF e l'utente della sessione, prima del primo
    // instradamento, così le guard sanno chi è autenticato.
    provideAppInitializer(() => {
      inject(ThemeService);
    }),
    provideAppInitializer(() => inject(AuthService).bootstrap()),
    // Lunghezza minima delle password dal server, prima che i moduli creino i validatori.
    provideAppInitializer(() => inject(PasswordPolicyService).load()),
  ],
};
